(() => {
  'use strict';
  const schemaNode = document.getElementById('et-phgg-product-schema');
  const variantsNode = document.getElementById('et-phgg-schema-variants');
  const section = document.querySelector('[data-etr-pdp][data-product-handle="wonderfoods-partially-hydrolysed-guar-gum-phgg"], [data-etr-pdp][data-product-handle="propel-health-partially-hydrolysed-guar-gum"]');
  if (!schemaNode || !variantsNode || !section) return;
  let schema, variants;
  try {
    schema = JSON.parse(schemaNode.textContent);
    variants = JSON.parse(variantsNode.textContent);
  } catch {
    return;
  }
  function syncSchema() {
    const id = section.querySelector('.etr-pdp__form [name="id"]')?.value;
    const variant = variants[id];
    if (!variant) return;
    schema.sku = variant.sku;
    schema.image = variant.image;
    schema.url = variant.url;
    if (variant.gtin) schema.gtin = variant.gtin;
    else delete schema.gtin;
    if (variant.weight > 0) {
      schema.weight = { '@type': 'QuantitativeValue', value: variant.weight, unitCode: 'KGM' };
    } else delete schema.weight;
    schema.offers.url = variant.url;
    schema.offers.price = Number(variant.price).toFixed(2);
    schema.offers.availability = `https://schema.org/${variant.available ? 'InStock' : 'OutOfStock'}`;
    schemaNode.textContent = JSON.stringify(schema);
  }
  section.addEventListener('change', event => {
    if (event.target.matches('.etr-pdp__form [name="id"]')) syncSchema();
  });
  syncSchema();
})();
